/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ImportExamItemGridItemRepositoryResponsePaginatedResponse } from "../types/ImportExamItemGridItemRepositoryResponsePaginatedResponse.ts";
import { importExamItemGridItemRepositoryResponseSchema } from "./importExamItemGridItemRepositoryResponseSchema.ts";

export const importExamItemGridItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => importExamItemGridItemRepositoryResponseSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<ImportExamItemGridItemRepositoryResponsePaginatedResponse>;
